import React, { useContext, useEffect } from 'react'
import { AppContext } from '../ContextApi'
import { useNavigate } from 'react-router-dom';

const CheckPageVisiblity = () => {

    const { featuresType} = useContext(AppContext) ;
    const navigate = useNavigate();

    useEffect(() =>{
        if((featuresType === "GPA" || featuresType === "GTL") && window.location.pathname == "/network-hospital"){
            navigate("/policy-details");
        }
     
    },[featuresType])

  return (
    <></>
  )
}

export default CheckPageVisiblity